import React from 'react';
import AppRouter from './AppRouter';
import './App.css';

const App = () => {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
};

export default App;